module.exports = __webpack_public_path__ + "assets/img/search_5.eddf15cd.png";